import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { CloudId } from '@atlassian/jira-shared-types/src/general.tsx';

const SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY = `
    query SelectedGlobalScopeIssueNavigatorQuery($cloudId: ID!) {
        myPreferences(keys: [
            "jira.user.nin.global.scope.enrolment"
        ]),
        jira {
            applicationPropertiesByKey(cloudId: $cloudId, keys: ["jira.admin.nin.global.scope.enrolment"]) {
                value
            }
        }
    }
`;

const fetchIsGlobalScopeEnrolmentEnabledFromServer = async (cloudId: CloudId) => {
	const apiResult = await performPostRequest('/rest/gira/1/', {
		body: JSON.stringify({
			query: SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY,
			variables: { cloudId },
		}),
	});

	const userPreferenceValue = apiResult.data.myPreferences['jira.user.nin.global.scope.enrolment'];
	if (
		userPreferenceValue !== 'nin' &&
		userPreferenceValue !== 'gin' &&
		userPreferenceValue !== null
	) {
		throw new RangeError('Unexpected user preference value');
	}

	const applicationPropertyValue = apiResult.data.jira.applicationPropertiesByKey[0].value;
	if (applicationPropertyValue !== 'true' && applicationPropertyValue !== 'false') {
		throw new RangeError('Unexpected application property value');
	}

	return userPreferenceValue !== 'gin' && applicationPropertyValue === 'true';
};

export default fetchIsGlobalScopeEnrolmentEnabledFromServer;
